import styled from 'styled-components'
import { DataTable } from 'components/atoms'

export const Table = styled(DataTable)`
  width: 100%;
`
